import sysManage from "./sysManage.js";
import allTabs from './allTabs.js';
import h5List from './h5List.js';

export default { sysManage, allTabs, h5List };